export default "__VITE_ASSET__7076a132__$_?nuxt_component=async__"